module.exports = __webpack_public_path__ + "static/media/spotr.c729f4a8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/spotr.webp
// module id = 306
// module chunks = 0